import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function DemoPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0F172A] via-[#0B1E3C] to-[#11263D] text-white font-sans px-4 relative overflow-hidden">
      {/* Dynamic Background Waves */}
      <div className="absolute top-0 left-0 w-full h-full z-0">
        <div className="absolute w-full h-full bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-purple-800/20 via-transparent to-transparent animate-pulse" />
        <div className="absolute w-full h-full bg-[radial-gradient(ellipse_at_bottom_right,_var(--tw-gradient-stops))] from-blue-800/20 via-transparent to-transparent animate-pulse" />
      </div>

      {/* Sticky Header */}
      <header className="sticky top-0 z-50 flex flex-wrap justify-between items-center py-6 px-4 w-full bg-transparent">
        <div className="flex items-center space-x-3">
          <h1 className="text-2xl font-extrabold text-white tracking-wide">Heradexia</h1>
        </div>
        <nav className="space-x-6 text-sm font-medium mt-2 sm:mt-0">
          <Link to="/" className="hover:text-[#8BC53F]">Join Waitlist</Link>
          <Link to="/how-it-works" className="hover:text-[#8BC53F]">How It Works</Link>
          <Link to="/use-demo" className="hover:text-[#8BC53F]">Use Demo</Link>
        </nav>
      </header>

      <main className="max-w-4xl mx-auto py-32 relative z-10 text-center">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-4xl md:text-5xl font-extrabold mb-6"
        >
          Heradexia Demo
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
          className="text-lg text-gray-300 mb-12 max-w-xl mx-auto"
        >
          Our interactive demo will be live on <span className="text-[#8BC53F] font-semibold">July 15th</span>. Stay tuned!
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.8, duration: 1 }}
          className="mt-10 py-12 px-8 bg-[#122B3E] bg-opacity-90 rounded-2xl border border-[#1F2937] shadow-xl"
        >
          <p className="text-xl text-purple-300 font-semibold">Coming Soon</p>
          <p className="text-gray-400 mt-2">We’re building something truly transformative. Mark your calendar and be the first to explore the future of learning.</p>
        </motion.div>
      </main>

      <footer className="mt-20 text-center text-xs text-gray-400 py-4 border-t border-gray-700">
        © 2025 Heradexia • Built with love and purpose.
      </footer>
    </div>
  );
}

